// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { scannerGun16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-scanner-gun': IconScannerGun;
    }
}

/**
 * The icon component for the 'scannerGun' icon
 */
export class IconScannerGun extends IconSvg {
    public constructor() {
        super(scannerGun16X16);
    }
}

registerIconSvg('icon-scanner-gun', IconScannerGun);
export const iconScannerGunTag = 'nimble-icon-scanner-gun';
